<div  class="card border-0 mb-3 overflow-hidden">
  <!-- BEGIN card-body -->
  <div class="panel panel-inverse">
    <div class="panel-heading">
      <h4 class="panel-title"><i class="fa-solid fa-hand-holding-dollar me-2"></i>Anticipos</h4>
      <div class="d-flex flex-row">
  

      </div>
    </div>
    <div class="panel-body">






    </div>
  </div>
</div>


